export default __webpack_public_path__ + "static/media/brainlogo.1cce37db.svg";